// extracted by mini-css-extract-plugin
export default {"root":"more-with-triangle-module-root-DtlFs"};